var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#2A2A2A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 18C16 17.7348 16.1054 17.4804 16.2929 17.2929C16.4804 17.1054 16.7348 17 17 17H31C31.2652 17 31.5196 17.1054 31.7071 17.2929C31.8946 17.4804 32 17.7348 32 18C32 18.2652 31.8946 18.5196 31.7071 18.7071C31.5196 18.8946 31.2652 19 31 19H17C16.7348 19 16.4804 18.8946 16.2929 18.7071C16.1054 18.5196 16 18.2652 16 18ZM16 24C16 23.7348 16.1054 23.4804 16.2929 23.2929C16.4804 23.1054 16.7348 23 17 23H31C31.2652 23 31.5196 23.1054 31.7071 23.2929C31.8946 23.4804 32 23.7348 32 24C32 24.2652 31.8946 24.5196 31.7071 24.7071C31.5196 24.8946 31.2652 25 31 25H17C16.7348 25 16.4804 24.8946 16.2929 24.7071C16.1054 24.5196 16 24.2652 16 24ZM17 29C16.7348 29 16.4804 29.1054 16.2929 29.2929C16.1054 29.4804 16 29.7348 16 30C16 30.2652 16.1054 30.5196 16.2929 30.7071C16.4804 30.8946 16.7348 31 17 31H31C31.2652 31 31.5196 30.8946 31.7071 30.7071C31.8946 30.5196 32 30.2652 32 30C32 29.7348 31.8946 29.4804 31.7071 29.2929C31.5196 29.1054 31.2652 29 31 29H17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.0c63e5a5674355bb47732ad634b1fefd.svg";
export { ForwardRef as ReactComponent };